const ENDPOINT = process.env.VUE_APP_API_URI.replace(/\/$/, '');

let __token = null;

function __fetch(url, opts){
  if(url.indexOf('http') !== 0)
  {
    url = ENDPOINT + url;
  }

  const headers = {
    'Content-type' : 'application/json',
    'Accept' : 'application/json',
    // 'X-CSRF-Token': __token,
    ...opts.headers
  }

  return new Promise((resolve, reject) => {
    fetch(url,{
      method: opts.method,
      // credentials: 'include',
      // mode: 'no-cors',
      body: opts.data||null,
      headers,
    })
    .then(async r => {
      const j = await r.json();
      if (r.status < 200 || r.status >= 300){
        reject({
          body: j,
          response: r,
        });
      } else {
        resolve({
          body: j,
          response: r,
        });
      }
    })
    .catch(e => {
      reject(e)
    })
  })
}

const api = {};

api.get = function(url, data, opts){
  opts = {'method':'GET', ...opts};
  if(data){
    let qs = [];
    for(let i in data){
      if(Object.prototype.hasOwnProperty.call(data, i)){
        qs.push(`${i}=${data[i]}`);
      }
    }
    url += '?' + qs.join('&');
  }
  return __fetch(url, opts)
}

api.post = function(url, data){
  return __fetch(url,{'method':'POST', data:JSON.stringify(data)});
}

api.put = function(url, data){
  return __fetch(url,{'method':'PUT', data:JSON.stringify(data)});
}

api.patch = function(url, data){
  return __fetch(url,{'method':'PATCH', data:JSON.stringify(data)});
}

api.delete = function(url){
  return __fetch(url,{'method':'DELETE'});
}

api.setToken = function(token){
  __token = token;
}

if((__token = localStorage.getItem('token')))
{
  api.setToken(__token)
}

export default api;